import { useMemo } from "react";
import { useProjectLocal } from "@/context/AppContext";
import {
  formatMoney,
  formatMoneyWhole,
  getCurrencyMeta,
  normalizeCurrency,
} from "@/lib/currency";

export function useCurrency(overrideCode) {
  const { data } = useProjectLocal();
  const code = normalizeCurrency(overrideCode || data?.business?.currency);

  return useMemo(() => {
    const meta = getCurrencyMeta(code);
    return {
      code,
      symbol: meta.symbol,
      name: meta.name,
      format: (amount) => formatMoney(amount, code),
      formatWhole: (amount) => formatMoneyWhole(amount, code),
    };
  }, [code]);
}
